/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmbassadorPurchaseSessionResponse } from '../../models/ambassador-purchase-session-response';
import { SilverAmbassadorPurchaseRequest } from '../../models/silver-ambassador-purchase-request';

export interface CreateSilverAmbassadorPurchaseSession$Params {
      body: SilverAmbassadorPurchaseRequest
}

export function createSilverAmbassadorPurchaseSession(http: HttpClient, rootUrl: string, params: CreateSilverAmbassadorPurchaseSession$Params, context?: HttpContext): Observable<StrictHttpResponse<AmbassadorPurchaseSessionResponse>> {
  const rb = new RequestBuilder(rootUrl, createSilverAmbassadorPurchaseSession.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmbassadorPurchaseSessionResponse>;
    })
  );
}

createSilverAmbassadorPurchaseSession.PATH = '/api/company/checkout-silver-ambassador-services';
